import VerifiedOutlined from '@mui/icons-material/VerifiedOutlined'

import Stack from '@mui/material/Stack'
import Link from '@components/_mui/Link'

import Section from '@components/Details/Section'

import Field from './Field'

export default function Program340BDetails({ data, isLoading }) {
  const info = data?.grant340BInformation

  return (
    <Section title="340B Details" icon={<VerifiedOutlined />}>
      <Stack sx={{ gap: 1 }}>
        <Field label="340B HRSA ID Number" isLoading={isLoading} value={info?.hrsaId} />
        <Field label="Entity EMR System" isLoading={isLoading} value={info?.entityEMRSystem} />
        <Field label="HRSA Grant Number" isLoading={isLoading} value={info?.hrsaGrantNumber} />
        <Field label="Grant Patient Definition" isLoading={isLoading} value={info?.grantPatientDefinition} />
        <Field label="Notice of Funding Number" isLoading={isLoading} value={info?.noticeOfFundingNumber} />
        <Field
          label="HRSA Details"
          isLoading={isLoading}
          value={
            info?.hrsaUrl && (
              <Link href={info.hrsaUrl} target="_blank" rel="noopener" sx={{ wordBreak: 'break-all' }}>
                {info.hrsaUrl}
              </Link>
            )
          }
        />
      </Stack>
    </Section>
  )
}
